import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import Unbutton from '../../../components/form/button/unbutton';
import useAuth from '../../../hooks/auth';
import InviteUsers from '../../../views/_components/invite';
import styles from './styles.module.css';
import logo from 'url:/public/images/logo-limbic-name.svg';

const Navbar: FC = () => {
  const { isAuthenticated, logout, hasPermission, isType } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  let inviteLink = null;

  if (hasPermission('USER_CREATE'))
    inviteLink = (
      <>
        <Unbutton
          style={{
            paddingLeft: '0',
            fontFamily: 'Aeroport',
            fontSize: '18px',
          }}
          onClick={handleOpen}>
          Invite staff
        </Unbutton>
        {isOpen && <InviteUsers isOpen={isOpen} onClose={handleClose} />}
      </>
    );

  let manageLink = null;

  if (isType('CLINICIAN') && hasPermission('CLINICIAN_EDIT'))
    manageLink = (
      <Link to="/users/manage/clinician" className={styles.link}>
        Manage staff
      </Link>
    );

  if (isType('ADMIN_CLINIC') && hasPermission('USER_CREATE'))
    manageLink = (
      <Link to="/users/manage/admin/clinic" className={styles.link}>
        Manage staff
      </Link>
    );

  let registerLink = null;

  if (hasPermission('PATIENT_CREATE'))
    registerLink = (
      <Link to="/patients/register" className={styles.link}>
        Register patient
      </Link>
    );

  return (
    <nav className={styles.wrapper}>
      <div className={styles.left}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src={logo} alt="Limbic Logo" className={styles.logo} />
        </Link>
      </div>

      {/* <div className={styles.center}>
        center
      </div> */}

      {isAuthenticated && (
        <div className={styles.rightWrapper}>
          <div className={styles.right}>
            <div>{manageLink}</div>
            <div>{registerLink}</div>
          </div>
          <div className={styles.right}>
            <div>{inviteLink}</div>
            <div>
              <Unbutton
                style={{
                  paddingLeft: '0',
                  fontFamily: 'Aeroport',
                  fontSize: '18px',
                }}
                onClick={logout}>
                Log out
              </Unbutton>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
